// assets/upside-eta.js
// Simon 2026-10-03: delivery estimate by province (business days, measured on 5,371 real orders).
//   QC, ON:     EN "Delivered in 1 to 3 business days" / FR "Livraison en 1 à 3 jours ouvrables"
//   NB, NS, PE: EN "Delivered in 2 to 4 business days" / FR "Livraison en 2 à 4 jours ouvrables"
//   Every other province (NL, MB), the territories, the US or an unknown region: nothing.
// West (BC, AB, SK), Simon 2026-10-13: the product page says which warehouse ships the selected
//   variant, from apps/upside-app-api /inventory (the regional stock service the site uses):
//   7 Mountain -> "Ships within 1 business day from our West warehouse" (techOMS: 94% of West orders)
//   Montreal   -> "Ships from Montreal: delivered in 7 to 9 business days" (median 7, 80th pct 9)
//   Reads the product form's selected id only (never touches the form or Add to Cart).
// Province = the one the theme already uses: window.ecomificShoppingLocation (header "Delivery: Québec"
// selector, detected or chosen). Updates live on "ecomific:shopping-location:changed".
// Two places: product page (under the "Free shipping: ON & QC on $75+" line, .ud-ship) and the
// Rebuy cart drawer (under the Subtotal, above Checkout). Loaded from layout/theme.liquid.
(function () {
  'use strict';
  if (window.__UD_ETA__) return;
  window.__UD_ETA__ = true;

  var FR = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
  var DAYS = { QC: '1|3', ON: '1|3', NB: '2|4', NS: '2|4', PE: '2|4' };
  var WEST = { BC: 1, AB: 1, SK: 1 };
  var STOCK = 'https://upside-app-api.gilles-577.workers.dev/inventory';
  var shipsFrom = {}; // variant id -> 'west' | 'east' | '' (asked once per page)
  var lastVariant = '';
  function variantId() {
    var f = document.querySelector('[id$="__main"] form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    var i = f && f.querySelector('[name="id"]');
    return i ? String(i.value || '') : '';
  }
  function westText(from) {
    if (from === 'west') return FR ? 'Expédié en 1 jour ouvrable depuis notre entrepôt de l’Ouest' : 'Ships within 1 business day from our West warehouse';
    if (from === 'east') return FR ? 'Expédié de Montréal : livré en 7 à 9 jours ouvrables' : 'Ships from Montreal: delivered in 7 to 9 business days';
    return '';
  }
  function pdpText(p) {
    if (!WEST[p]) return text(p);
    var v = variantId();
    if (!v) return '';
    if (!(v in shipsFrom)) {
      shipsFrom[v] = '';
      fetch(STOCK + '?variant_id=' + encodeURIComponent(v) + '&region=west', { credentials: 'omit' })
        .then(function (r) { return r.json(); })
        .then(function (j) { shipsFrom[v] = j && j.ok && (j.ships_from === 'west' || j.ships_from === 'east') ? j.ships_from : ''; soon(); })
        .catch(function () {});
    }
    return westText(shipsFrom[v]);
  }
  function text(p) {
    var d = DAYS[p]; if (!d) return '';
    d = d.split('|');
    return FR ? 'Livraison en ' + d[0] + ' à ' + d[1] + ' jours ouvrables' : 'Delivered in ' + d[0] + ' to ' + d[1] + ' business days';
  }
  var ICON = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#37446E" stroke-width="2" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/></svg>';

  var st = document.createElement('style');
  st.textContent =
    '.ud-eta{font-family:Arial,Helvetica,sans-serif;font-size:12.5px;color:#4b5563;display:flex;align-items:center;gap:6px;margin-top:6px}' +
    '.ud-eta svg{flex:0 0 auto}' +
    '.ud-eta--cart{justify-content:center;margin:2px 0 10px}';
  document.head.appendChild(st);

  function province() {
    try {
      var L = window.ecomificShoppingLocation;
      return String((L && L.getLocation && L.getLocation()) || '').trim().toUpperCase();
    } catch (e) { return ''; }
  }
  function make(mod, txt) {
    var d = document.createElement('div');
    d.className = 'ud-eta ud-eta--' + mod;
    d.innerHTML = ICON + '<span>' + txt + '</span>';
    return d;
  }
  // keep exactly one line right after its anchor (with the right text), or none
  function place(anchor, mod, txt) {
    var ex = document.querySelectorAll('.ud-eta--' + mod);
    if (!txt || !anchor) { ex.forEach(function (n) { n.remove(); }); return; }
    if (ex.length === 1 && ex[0].previousElementSibling === anchor && ex[0].textContent === txt) return;
    ex.forEach(function (n) { n.remove(); });
    anchor.parentNode.insertBefore(make(mod, txt), anchor.nextSibling);
  }
  function all() {
    place(document.querySelector('[id$="__main"] .ud-ship'), 'pdp', pdpText(province()));
    // Rebuy Smart Cart today, our drawer (assets/upside-cart.js, #ud-cart) after the switch
    place(document.querySelector('.rebuy-cart__flyout .rebuy-cart__flyout-subtotal') || document.querySelector('#ud-cart .ud-cart__sub'), 'cart', WEST[province()] ? '' : text(province()));
  }

  var raf = 0;
  function soon() { if (!raf) raf = requestAnimationFrame(function () { raf = 0; all(); }); }
  window.addEventListener('ecomific:shopping-location:ready', soon);
  window.addEventListener('ecomific:shopping-location:changed', soon);
  function start() {
    all();
    // the free-shipping line and the Rebuy drawer are drawn late and re-rendered: re-place when the page changes
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        var t = ms[i].target;
        if (t.nodeType === 1 && t.closest && t.closest('.ud-eta')) continue;
        soon(); return;
      }
    }).observe(document.body, { childList: true, subtree: true });
    // A variant change only rewrites the form's hidden id: check it once a second (read only).
    setInterval(function () { var v = variantId(); if (v !== lastVariant) { lastVariant = v; soon(); } }, 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
